import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminListProxyByUserComponent from "../../../components/Admin/users/AdminListProxyByUserComponent";

const AdminListProxyByUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <AdminListProxyByUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
    />;
}

export default AdminListProxyByUserPage;